/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use FlexDirectionEnum from application-types instead.
 */
export enum FlexDirectionEnum {
  Vertical = 'column',
  Horizontal = 'row',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use FlexJustifyContentEnum from application-types instead.
 */
export enum FlexJustifyContentEnum {
  Start = 'flex-start',
  End = 'flex-end',
  Center = 'center',
  SpaceBetween = 'space-between',
  SpaceEvenly = 'space-evenly',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use FlexAlignItemsEnum from application-types instead.
 */
export enum FlexAlignItemsEnum {
  Start = 'flex-start',
  End = 'flex-end',
  Center = 'center',
  Baseline = 'baseline',
  Stretch = 'stretch',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use FlexWrapEnum from application-types instead.
 */
export enum FlexWrapEnum {
  Wrap = 'wrap',
  WrapReverse = 'wrap-reverse',
  NoWrap = 'nowrap',
}
